import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';

export type CustomAutocompleteProp = {
  type: 'autocomplete';
  name: string;
  label: string;
  options: object[];
  getOptionLabel: string;
  fullWidth?: boolean;
  rule?: RegisterOptions;
  showErrorMessage?: boolean;
  autocompleteProps?: { multiple?: boolean; size?: any; style?: any };
  onChange?: (value: any) => void;
};

const CustomAutocomplete: React.FC<CustomAutocompleteProp> = ({
  name,
  label,
  options,
  getOptionLabel,
  rule,
  showErrorMessage = true,
  autocompleteProps,
  onChange = () => {},
}) => {
  const { setValue, control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rule}
      defaultValue={autocompleteProps?.multiple ? [] : null}
      render={({ field, fieldState }) => {
        return (
          <Autocomplete
            fullWidth
            filterSelectedOptions={true}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id;
            }}
            getOptionLabel={(option) => option[getOptionLabel] ?? ''}
            ref={field.ref}
            value={field.value}
            onChange={(e, newValue) => {
              setValue(name, newValue);
              onChange(newValue);
            }}
            options={options}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  label={label}
                  error={!!fieldState.error}
                  helperText={showErrorMessage ? fieldState.error?.message : null}
                />
              );
            }}
            {...autocompleteProps}
          />
        );
      }}
    />
  );
};

export default CustomAutocomplete;
